export default __webpack_public_path__ + "static/media/serenad8.53479d70.png";